<template>
  <!-- Change viewBox and fill params -->
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
    viewBox="0 0 39 32"
  >
    <g>
      <path
        fill="#4365e2"
        d="M39.385 3.775c-1.339 0.646-2.895 1.108-4.532 1.302l-0.070 0.007c1.655-1.032 2.918-2.557 3.598-4.368l0.020-0.060c-1.459 0.916-3.165 1.602-4.99 1.954l-0.094 0.015c-1.54-1.595-3.687-2.594-6.068-2.625l-0.006-0c-4.46 0.001-8.076 3.617-8.076 8.078 0 0.627 0.071 1.237 0.207 1.823l-0.011-0.054c-6.706-0.285-12.615-3.471-16.539-8.327l-0.033-0.042c-0.699 1.175-1.112 2.59-1.112 4.102 0 2.788 1.405 5.248 3.546 6.71l0.028 0.018c-1.337-0.143-2.559-0.492-3.684-1.015l0.072 0.030c-0.001 0.041-0.001 0.090-0.001 0.138 0 3.867 2.718 7.1 6.348 7.892l0.053 0.010c-0.664 0.177-1.427 0.278-2.213 0.278-0.493 0-0.976-0.040-1.448-0.117l0.052 0.007c0.982 3.25 3.95 5.576 7.462 5.576 0.030 0 0.060-0 0.091-0.001l-0.005 0c-2.754 2.119-6.251 3.396-10.046 3.396-0.681 0-1.352-0.041-2.012-0.121l0.079 0.008c3.483 2.254 7.737 3.598 12.305 3.609h0.003c0.037 0 0.081 0 0.125 0 12.634 0 22.876-10.242 22.876-22.876 0-0.381-0.009-0.76-0.028-1.137l0.002 0.053c1.613-1.182 2.973-2.595 4.064-4.205l0.038-0.060z"
      />
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    width: {
      type: String,
      default: ''
    },
    height: {
      type: String,
      default: ''
    },
    color: {
      type: String,
      default: ''
    }
  }
}
</script>
